import { useCallback } from 'react';
import { UserFragment } from '../generated/graphql';

export const useDisplayName = () =>
  useCallback<(user: Partial<UserFragment> | undefined) => string>(
    (user) => user?.username ?? user?.email ?? '',
    [],
  );
